
import { Component, Prop, Vue } from 'vue-property-decorator';

import store from '@/store';

import AvatarRanking from '@/components/AvatarRanking/index.vue';

import ExpIcon from '@/assets/icons/Exp.vue';

import { RankingData, User } from '@/globalInterfaces/Gamification';

@Component({
  components: {
    AvatarRanking,
    ExpIcon
  },
  filters: {
    formatPosition(value: number) {
      return value > 100 ? '100+' : `${value || ''}`;
    }
  }
})
export default class RankingUser extends Vue {
  @Prop({ required: true }) ranking!: RankingData;

  get formatName() {
    const { user } = this.ranking;
    if (!user) return '';

    const { idstudent } = store.getters.profile;
    const userName = user.nickname || user.name;
    const splitName = userName.split(' ');

    if (idstudent && user.ID === idstudent) return `${splitName[0]} ${this.$t('you')}`;

    return splitName[0];
  }
}
